import { render, staticRenderFns } from "./ManagerAdd.vue?vue&type=template&id=4157b611"
import script from "./ManagerAdd.vue?vue&type=script&lang=js"
export * from "./ManagerAdd.vue?vue&type=script&lang=js"
import style0 from "./ManagerAdd.vue?vue&type=style&index=0&id=4157b611&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports